<!--
 * @Description: 
 * @version: 
 * @Author: 李云飞
 * @Date: 2023-07-15 09:52:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-11 15:20:07
-->
<template>
  <div class="tab-bar">
    <a-tabs :activeKey="activeKey"
            @tabClick="tabClick">
      <a-tab-pane tab="首页"
                  :key="HOME_PAGE">
      </a-tab-pane>
      <a-tab-pane v-for="(item,index) in pageTagList"
                  :key="item.name"
                  :closable="true">
        <template #tab>
          <div class="tab-pane-slot">
            <a-dropdown trigger="contextmenu">
              <div class="tab-pane-title">{{item.meta.title}}</div>
              <template #overlay>
                <a-menu>
                  <a-menu-item>
                    <a @click="closeOther">关闭其他</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <CloseOutlined class="tab-pane-close"
                           @click.stop="closeTagItem(item)" />
          </div>
        </template>
      </a-tab-pane>
      <template #rightExtra>
        <a-dropdown trigger="click">
          <MenuOutlined class="close-menu-button" />
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <a @click="closeOther">关闭其他</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="closeAll">关闭所有</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-tabs>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useSystemStore } from '@/store/system.js';
import lodash from 'lodash';
import localStorageKeyConst from '@/constants/local-storage-key-const';

const { HOME_PAGE } = localStorageKeyConst;

const router = useRouter();
const route = useRoute();

// 当前激活的tag
const activeKey = computed(() => route.name);

// 标签数据
const pageTagList = computed(() => useSystemStore().getPageTags || []);

// tab 被点击的回调
function tabClick(itemName) {
  if (itemName === activeKey.value) {
    return;
  }
  if (itemName === HOME_PAGE) {
    router.push({ name: HOME_PAGE });
    return;
  }
  const tagItem = pageTagList.value.find((item) => item.name === itemName);
  router.push({
    name: tagItem.name,
    query: tagItem.query,
    params: tagItem.params,
  });
}

// 关闭一个tag
function closeTagItem(item) {
  useSystemStore().closePageAndPush(item.name, activeKey.value);
}

// 关闭其他
function closeOther() {
  if (lodash.isEmpty(pageTagList.value)) {
    return;
  }
  const otherTagList = pageTagList.value.filter((item) => item.name !== activeKey.value);
  for (let i = 0; i < otherTagList.length; i++) {
    useSystemStore().removePageTag(otherTagList[i]);
  }
}

// 关闭所有
function closeAll() {
  if (lodash.isEmpty(pageTagList.value)) {
    return;
  }
  useSystemStore().clearPageTag();
  router.push({ name: HOME_PAGE });
}
</script>

<style lang="less" scoped>
.tab-bar {
  padding: 0 8px;
  background: #fff;
  ::v-deep(.ant-tabs-nav) {
    margin-bottom: 0;
  }
}

.tab-pane-slot {
  display: flex;
  align-items: center;
  column-gap: 6px;
  .tab-pane-title {
  }
  .tab-pane-close {
    margin-right: 0;
    font-size: 12px;
  }
}

.close-menu-button {
  cursor: pointer;
}
</style>
